import {
  coProbationPhoneLines,
  coProbationProgramCallOptions,
  coProbationResearchGaps,
  coTestingLocationDocuments,
  coTestingLocationListings,
  getCoProbationProgramCallProfile,
  type CoProbationProgramCallProfile,
} from "@constructorfleet/co-ua-data";

function isDefined<T>(value: T | undefined): value is T {
  return value !== undefined;
}

export const uaCoveredCounties = ["Jefferson County", "Weld County"] as const;

export const uaProgramProfiles: CoProbationProgramCallProfile[] = coProbationProgramCallOptions
  .map((option) => getCoProbationProgramCallProfile(option.id))
  .filter(isDefined);

export const uaCoverageStats = {
  phoneLineCount: coProbationPhoneLines.length,
  monitoredProgramCount: uaProgramProfiles.length,
  testingLocationCount: coTestingLocationListings.length,
  sourceDocumentCount: coTestingLocationDocuments.length,
  countyCount: uaCoveredCounties.length,
} as const;

export const uaOfferingResearchDataset = {
  phoneLines: coProbationPhoneLines,
  programProfiles: uaProgramProfiles,
  testingLocationDocuments: coTestingLocationDocuments,
  testingLocations: coTestingLocationListings,
  researchGaps: coProbationResearchGaps,
  coveredCounties: uaCoveredCounties,
} as const;

/** @deprecated Use uaCoveredCounties instead */
export const coUaCoveredCounties = uaCoveredCounties;
/** @deprecated Use uaProgramProfiles instead */
export const coUaProgramProfiles = uaProgramProfiles;
/** @deprecated Use uaCoverageStats instead */
export const coUaCoverageStats = uaCoverageStats;
/** @deprecated Use uaOfferingResearchDataset instead */
export const coUaOfferingResearchDataset = uaOfferingResearchDataset;
